// extracted by mini-css-extract-plugin
export default {"previewImageLaptop":"dbTew2WOdZAW7nT3h0Rh","previewImageMobile":"jGyb6xuYgpFM_Wyh7fwg","tabs":"_3n2_trP2OZ9D8myEYLJO","qr":"LblgcOPEsCP1mS93BbvY"};